import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import type { ClassReportType, HighlightedProps } from '../../types';
import { SectionLayout, getFilteredAverage, getOthersAverage } from '../modules';
import { StudentProgress } from '../../../components';

type Props = {
  classReport: ClassReportType;
  showOthersData: boolean
  hideAverage?: boolean
  chartIsExpanded?: boolean
} & HighlightedProps;

const Progressions = ({
  classReport,
  showOthersData,
  highlightedLabel,
  highlightedIds,
  hideAverage,
  chartIsExpanded,
  onElementClick,
}: Props): JSX.Element => {
  const { translate } = useI18n();

  const value = classReport.progressionAverage.toFixed(2);
  const highlightedAverage = highlightedLabel
    ? getFilteredAverage(classReport.students.all, highlightedIds, (student) => student.chartsData.mathsAge > 0 ? student.chartsData.progression : null)
    : null;
  const othersAverage = showOthersData
    ? getOthersAverage(classReport.students.all, highlightedIds, (student) => student.chartsData.mathsAge > 0 ? student.chartsData.progression : null)
    : null;

  return (
    <SectionLayout
      title={translate('pages.REPORTS.SECTIONS.PROGRESSIONS.title')}
      value={value}
      highlightLabel={highlightedLabel}
      highlightValue={highlightedAverage?.toFixed(2) ?? null}
      othersLabel={showOthersData && highlightedIds.length > 0 ? translate('pages.REPORTS.HEADERS.OTHERS') : null}
      othersValue={othersAverage?.toFixed(2) ?? null}
      description={translate('pages.REPORTS.SECTIONS.PROGRESSIONS.description')}
      moreInfo={translate('pages.REPORTS.SECTIONS.PROGRESSIONS.info')}
      className={'pdf-no-break'}
      data-cy="progressions"
      hideAverage={hideAverage}
      chartIsExpanded={chartIsExpanded}
      id='progressions-container'
    >
      <StudentProgress
        showOthersData={showOthersData}
        data={classReport.students.all ?? []}
        chartType={'progression'}
        highlightedIds={highlightedIds}
        removeUnassessed={true}
        onElementClick={onElementClick}
      />
    </SectionLayout>
  );
};

Progressions.displayName = 'Progressions';

export default Progressions;
